import Colors from '@/utils/colors';
import { globalTheme } from './globalTheme';

const d = Colors.dark;

/**
 * Espelho de light.ts sobre as superfícies escuras. Mesmos componentes, mesmos espaçamentos;
 * só trocam cores. Tudo que aqui é hex fixo tem um par em `--alm-*` (main.scss).
 */
export const darkThemeOverrides = {
	...globalTheme,
	common: {
		...Colors.naiveBrand(),
		textColorBase: d.text,
		bodyColor: d.canvas,
		cardColor: d.surface,
		modalColor: d.surface,
		popoverColor: d.surface2,
		borderColor: d.border,
		dividerColor: d.border,
	},
	Layout: {
		color: d.canvas,
		headerColor: d.surface,
		siderColor: d.surface,
		headerBorderColor: d.border,
		siderBorderColor: d.border,
	},
	DataTable: {
		borderColor: d.border,
		thColor: d.surface,
		thTextColor: d.textMuted,
		thFontWeight: '600',
		tdColor: d.surface,
		tdColorHover: d.surface2,
		tdColorStriped: d.surface,
		thPaddingMedium: '8px 12px',
		tdPaddingMedium: '4px 12px',
		fontSizeMedium: '13px',
		lineHeight: '1.3',
		boxShadowBefore: 'inset -8px 0 8px -8px rgba(0, 0, 0, 0.45)',
		boxShadowAfter: 'inset 8px 0 8px -8px rgba(0, 0, 0, 0.45)',
	},
	Table: {
		borderColor: d.border,
		thColor: d.surface2,
		tdColor: d.surface,
		tdColorHover: d.surface2,
		tdColorStriped: d.surface2,
	},
	Card: {
		color: d.surface,
		borderColor: d.border,
		borderRadius: '16px',
	},
	Descriptions: {
		thFontWeight: 'bold',
		thColor: '',
		tdColor: '',
		borderColor: d.border,
	},
	Input: {
		color: d.surface2,
		colorFocus: d.surface2,
		border: `1px solid ${d.border}`,
		borderHover: `1px solid ${Colors.primaryColor}`,
		borderFocus: `1px solid ${Colors.primaryColor}`,
	},
	Button: {
		fontWeight: '500',
	},
};
